/*
    * Handler functions that perform modifications of data in the state tree
*/
import { MutationTree } from "vuex";
import { EditProfile } from "./types";

/*
    * Computed properties
*/
export const mutations: MutationTree<EditProfile> = {
};
